/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedTabRouteImport } from './routes/_authenticated/$tab'
import { Route as errors503RouteImport } from './routes/(errors)/503'
import { Route as errors500RouteImport } from './routes/(errors)/500'
import { Route as errors404RouteImport } from './routes/(errors)/404'
import { Route as errors403RouteImport } from './routes/(errors)/403'
import { Route as errors401RouteImport } from './routes/(errors)/401'
import { Route as authSignUpRouteImport } from './routes/(auth)/sign-up'
import { Route as authSignInRouteImport } from './routes/(auth)/sign-in'
import { Route as authForgotPasswordRouteImport } from './routes/(auth)/forgot-password'
import { Route as AuthenticatedTrackingIndexRouteImport } from './routes/_authenticated/tracking/index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedFrontlineIndexRouteImport } from './routes/_authenticated/frontline/index'
import { Route as AuthenticatedUsedVehicleSellerPlanningIndexRouteImport } from './routes/_authenticated/used-vehicle-seller/planning/index'
import { Route as AuthenticatedUsedVehicleSellerLeadPerformanceIndexRouteImport } from './routes/_authenticated/used-vehicle-seller/lead-performance/index'
import { Route as AuthenticatedUsedVehicleSellerContactOpsIndexRouteImport } from './routes/_authenticated/used-vehicle-seller/contact-ops/index'
import { Route as AuthenticatedUsedVehicleBuyerPlanningIndexRouteImport } from './routes/_authenticated/used-vehicle-buyer/planning/index'
import { Route as AuthenticatedUsedVehicleBuyerLeadPerformanceIndexRouteImport } from './routes/_authenticated/used-vehicle-buyer/lead-performance/index'
import { Route as AuthenticatedUsedVehicleBuyerContactOpsIndexRouteImport } from './routes/_authenticated/used-vehicle-buyer/contact-ops/index'
import { Route as AuthenticatedNewVehicleTransferLeadsIndexRouteImport } from './routes/_authenticated/new-vehicle/transfer-leads/index'
import { Route as AuthenticatedNewVehicleSubstitutesIndexRouteImport } from './routes/_authenticated/new-vehicle/substitutes/index'
import { Route as AuthenticatedNewVehicleRetailsIndexRouteImport } from './routes/_authenticated/new-vehicle/retails/index'
import { Route as AuthenticatedNewVehiclePriceListsIndexRouteImport } from './routes/_authenticated/new-vehicle/price-lists/index'
import { Route as AuthenticatedNewVehiclePlanningIndexRouteImport } from './routes/_authenticated/new-vehicle/planning/index'
import { Route as AuthenticatedNewVehicleOffersIndexRouteImport } from './routes/_authenticated/new-vehicle/offers/index'
import { Route as AuthenticatedNewVehicleLeadPerformanceIndexRouteImport } from './routes/_authenticated/new-vehicle/lead-performance/index'
import { Route as AuthenticatedNewVehicleInventoryIndexRouteImport } from './routes/_authenticated/new-vehicle/inventory/index'
import { Route as AuthenticatedNewVehicleImportedLeadsIndexRouteImport } from './routes/_authenticated/new-vehicle/imported-leads/index'
import { Route as AuthenticatedNewVehicleFunnelSetupIndexRouteImport } from './routes/_authenticated/new-vehicle/funnel-setup/index'
import { Route as AuthenticatedNewVehicleCustomersIndexRouteImport } from './routes/_authenticated/new-vehicle/customers/index'
import { Route as AuthenticatedNewVehicleContactOpsIndexRouteImport } from './routes/_authenticated/new-vehicle/contact-ops/index'
import { Route as AuthenticatedNewVehicleBookingsIndexRouteImport } from './routes/_authenticated/new-vehicle/bookings/index'
import { Route as AuthenticatedGenericUsersIndexRouteImport } from './routes/_authenticated/generic/users/index'
import { Route as AuthenticatedGenericModelsIndexRouteImport } from './routes/_authenticated/generic/models/index'
import { Route as AuthenticatedGenericIntegrationsIndexRouteImport } from './routes/_authenticated/generic/integrations/index'
import { Route as AuthenticatedGenericConfigurationIndexRouteImport } from './routes/_authenticated/generic/configuration/index'
import { Route as AuthenticatedGenericBusinessAgentsIndexRouteImport } from './routes/_authenticated/generic/business-agents/index'
import { Route as AuthenticatedGenericBranchIndexRouteImport } from './routes/_authenticated/generic/branch/index'
import { Route as AuthenticatedGenericAutoExclusionsIndexRouteImport } from './routes/_authenticated/generic/auto-exclusions/index'

const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedTabRoute = AuthenticatedTabRouteImport.update({
  id: '/$tab',
  path: '/$tab',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const errors503Route = errors503RouteImport.update({
  id: '/(errors)/503',
  path: '/503',
  getParentRoute: () => rootRouteImport,
} as any)
const errors500Route = errors500RouteImport.update({
  id: '/(errors)/500',
  path: '/500',
  getParentRoute: () => rootRouteImport,
} as any)
const errors404Route = errors404RouteImport.update({
  id: '/(errors)/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const errors403Route = errors403RouteImport.update({
  id: '/(errors)/403',
  path: '/403',
  getParentRoute: () => rootRouteImport,
} as any)
const errors401Route = errors401RouteImport.update({
  id: '/(errors)/401',
  path: '/401',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignUpRoute = authSignUpRouteImport.update({
  id: '/(auth)/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const authSignInRoute = authSignInRouteImport.update({
  id: '/(auth)/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const authForgotPasswordRoute = authForgotPasswordRouteImport.update({
  id: '/(auth)/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedTrackingIndexRoute =
  AuthenticatedTrackingIndexRouteImport.update({
    id: '/tracking/',
    path: '/tracking/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedFrontlineIndexRoute =
  AuthenticatedFrontlineIndexRouteImport.update({
    id: '/frontline/',
    path: '/frontline/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUsedVehicleSellerPlanningIndexRoute =
  AuthenticatedUsedVehicleSellerPlanningIndexRouteImport.update({
    id: '/used-vehicle-seller/planning/',
    path: '/used-vehicle-seller/planning/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUsedVehicleSellerLeadPerformanceIndexRoute =
  AuthenticatedUsedVehicleSellerLeadPerformanceIndexRouteImport.update({
    id: '/used-vehicle-seller/lead-performance/',
    path: '/used-vehicle-seller/lead-performance/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUsedVehicleSellerContactOpsIndexRoute =
  AuthenticatedUsedVehicleSellerContactOpsIndexRouteImport.update({
    id: '/used-vehicle-seller/contact-ops/',
    path: '/used-vehicle-seller/contact-ops/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUsedVehicleBuyerPlanningIndexRoute =
  AuthenticatedUsedVehicleBuyerPlanningIndexRouteImport.update({
    id: '/used-vehicle-buyer/planning/',
    path: '/used-vehicle-buyer/planning/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUsedVehicleBuyerLeadPerformanceIndexRoute =
  AuthenticatedUsedVehicleBuyerLeadPerformanceIndexRouteImport.update({
    id: '/used-vehicle-buyer/lead-performance/',
    path: '/used-vehicle-buyer/lead-performance/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUsedVehicleBuyerContactOpsIndexRoute =
  AuthenticatedUsedVehicleBuyerContactOpsIndexRouteImport.update({
    id: '/used-vehicle-buyer/contact-ops/',
    path: '/used-vehicle-buyer/contact-ops/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedNewVehicleTransferLeadsIndexRoute =
  AuthenticatedNewVehicleTransferLeadsIndexRouteImport.update({
    id: '/new-vehicle/transfer-leads/',
    path: '/new-vehicle/transfer-leads/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedNewVehicleSubstitutesIndexRoute =
  AuthenticatedNewVehicleSubstitutesIndexRouteImport.update({
    id: '/new-vehicle/substitutes/',
    path: '/new-vehicle/substitutes/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedNewVehicleRetailsIndexRoute =
  AuthenticatedNewVehicleRetailsIndexRouteImport.update({
    id: '/new-vehicle/retails/',
    path: '/new-vehicle/retails/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedNewVehiclePriceListsIndexRoute =
  AuthenticatedNewVehiclePriceListsIndexRouteImport.update({
    id: '/new-vehicle/price-lists/',
    path: '/new-vehicle/price-lists/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedNewVehiclePlanningIndexRoute =
  AuthenticatedNewVehiclePlanningIndexRouteImport.update({
    id: '/new-vehicle/planning/',
    path: '/new-vehicle/planning/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedNewVehicleOffersIndexRoute =
  AuthenticatedNewVehicleOffersIndexRouteImport.update({
    id: '/new-vehicle/offers/',
    path: '/new-vehicle/offers/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedNewVehicleLeadPerformanceIndexRoute =
  AuthenticatedNewVehicleLeadPerformanceIndexRouteImport.update({
    id: '/new-vehicle/lead-performance/',
    path: '/new-vehicle/lead-performance/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedNewVehicleInventoryIndexRoute =
  AuthenticatedNewVehicleInventoryIndexRouteImport.update({
    id: '/new-vehicle/inventory/',
    path: '/new-vehicle/inventory/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedNewVehicleImportedLeadsIndexRoute =
  AuthenticatedNewVehicleImportedLeadsIndexRouteImport.update({
    id: '/new-vehicle/imported-leads/',
    path: '/new-vehicle/imported-leads/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedNewVehicleFunnelSetupIndexRoute =
  AuthenticatedNewVehicleFunnelSetupIndexRouteImport.update({
    id: '/new-vehicle/funnel-setup/',
    path: '/new-vehicle/funnel-setup/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedNewVehicleCustomersIndexRoute =
  AuthenticatedNewVehicleCustomersIndexRouteImport.update({
    id: '/new-vehicle/customers/',
    path: '/new-vehicle/customers/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedNewVehicleContactOpsIndexRoute =
  AuthenticatedNewVehicleContactOpsIndexRouteImport.update({
    id: '/new-vehicle/contact-ops/',
    path: '/new-vehicle/contact-ops/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedNewVehicleBookingsIndexRoute =
  AuthenticatedNewVehicleBookingsIndexRouteImport.update({
    id: '/new-vehicle/bookings/',
    path: '/new-vehicle/bookings/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedGenericUsersIndexRoute =
  AuthenticatedGenericUsersIndexRouteImport.update({
    id: '/generic/users/',
    path: '/generic/users/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedGenericModelsIndexRoute =
  AuthenticatedGenericModelsIndexRouteImport.update({
    id: '/generic/models/',
    path: '/generic/models/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedGenericIntegrationsIndexRoute =
  AuthenticatedGenericIntegrationsIndexRouteImport.update({
    id: '/generic/integrations/',
    path: '/generic/integrations/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedGenericConfigurationIndexRoute =
  AuthenticatedGenericConfigurationIndexRouteImport.update({
    id: '/generic/configuration/',
    path: '/generic/configuration/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedGenericBusinessAgentsIndexRoute =
  AuthenticatedGenericBusinessAgentsIndexRouteImport.update({
    id: '/generic/business-agents/',
    path: '/generic/business-agents/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedGenericBranchIndexRoute =
  AuthenticatedGenericBranchIndexRouteImport.update({
    id: '/generic/branch/',
    path: '/generic/branch/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedGenericAutoExclusionsIndexRoute =
  AuthenticatedGenericAutoExclusionsIndexRouteImport.update({
    id: '/generic/auto-exclusions/',
    path: '/generic/auto-exclusions/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/forgot-password': typeof authForgotPasswordRoute
  '/sign-in': typeof authSignInRoute
  '/sign-up': typeof authSignUpRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/$tab': typeof AuthenticatedTabRoute
  '/': typeof AuthenticatedIndexRoute
  '/frontline': typeof AuthenticatedFrontlineIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/tracking': typeof AuthenticatedTrackingIndexRoute
  '/generic/auto-exclusions': typeof AuthenticatedGenericAutoExclusionsIndexRoute
  '/generic/branch': typeof AuthenticatedGenericBranchIndexRoute
  '/generic/business-agents': typeof AuthenticatedGenericBusinessAgentsIndexRoute
  '/generic/configuration': typeof AuthenticatedGenericConfigurationIndexRoute
  '/generic/integrations': typeof AuthenticatedGenericIntegrationsIndexRoute
  '/generic/models': typeof AuthenticatedGenericModelsIndexRoute
  '/generic/users': typeof AuthenticatedGenericUsersIndexRoute
  '/new-vehicle/bookings': typeof AuthenticatedNewVehicleBookingsIndexRoute
  '/new-vehicle/contact-ops': typeof AuthenticatedNewVehicleContactOpsIndexRoute
  '/new-vehicle/customers': typeof AuthenticatedNewVehicleCustomersIndexRoute
  '/new-vehicle/funnel-setup': typeof AuthenticatedNewVehicleFunnelSetupIndexRoute
  '/new-vehicle/imported-leads': typeof AuthenticatedNewVehicleImportedLeadsIndexRoute
  '/new-vehicle/inventory': typeof AuthenticatedNewVehicleInventoryIndexRoute
  '/new-vehicle/lead-performance': typeof AuthenticatedNewVehicleLeadPerformanceIndexRoute
  '/new-vehicle/offers': typeof AuthenticatedNewVehicleOffersIndexRoute
  '/new-vehicle/planning': typeof AuthenticatedNewVehiclePlanningIndexRoute
  '/new-vehicle/price-lists': typeof AuthenticatedNewVehiclePriceListsIndexRoute
  '/new-vehicle/retails': typeof AuthenticatedNewVehicleRetailsIndexRoute
  '/new-vehicle/substitutes': typeof AuthenticatedNewVehicleSubstitutesIndexRoute
  '/new-vehicle/transfer-leads': typeof AuthenticatedNewVehicleTransferLeadsIndexRoute
  '/used-vehicle-buyer/contact-ops': typeof AuthenticatedUsedVehicleBuyerContactOpsIndexRoute
  '/used-vehicle-buyer/lead-performance': typeof AuthenticatedUsedVehicleBuyerLeadPerformanceIndexRoute
  '/used-vehicle-buyer/planning': typeof AuthenticatedUsedVehicleBuyerPlanningIndexRoute
  '/used-vehicle-seller/contact-ops': typeof AuthenticatedUsedVehicleSellerContactOpsIndexRoute
  '/used-vehicle-seller/lead-performance': typeof AuthenticatedUsedVehicleSellerLeadPerformanceIndexRoute
  '/used-vehicle-seller/planning': typeof AuthenticatedUsedVehicleSellerPlanningIndexRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof authForgotPasswordRoute
  '/sign-in': typeof authSignInRoute
  '/sign-up': typeof authSignUpRoute
  '/401': typeof errors401Route
  '/403': typeof errors403Route
  '/404': typeof errors404Route
  '/500': typeof errors500Route
  '/503': typeof errors503Route
  '/$tab': typeof AuthenticatedTabRoute
  '/': typeof AuthenticatedIndexRoute
  '/frontline': typeof AuthenticatedFrontlineIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/tracking': typeof AuthenticatedTrackingIndexRoute
  '/generic/auto-exclusions': typeof AuthenticatedGenericAutoExclusionsIndexRoute
  '/generic/branch': typeof AuthenticatedGenericBranchIndexRoute
  '/generic/business-agents': typeof AuthenticatedGenericBusinessAgentsIndexRoute
  '/generic/configuration': typeof AuthenticatedGenericConfigurationIndexRoute
  '/generic/integrations': typeof AuthenticatedGenericIntegrationsIndexRoute
  '/generic/models': typeof AuthenticatedGenericModelsIndexRoute
  '/generic/users': typeof AuthenticatedGenericUsersIndexRoute
  '/new-vehicle/bookings': typeof AuthenticatedNewVehicleBookingsIndexRoute
  '/new-vehicle/contact-ops': typeof AuthenticatedNewVehicleContactOpsIndexRoute
  '/new-vehicle/customers': typeof AuthenticatedNewVehicleCustomersIndexRoute
  '/new-vehicle/funnel-setup': typeof AuthenticatedNewVehicleFunnelSetupIndexRoute
  '/new-vehicle/imported-leads': typeof AuthenticatedNewVehicleImportedLeadsIndexRoute
  '/new-vehicle/inventory': typeof AuthenticatedNewVehicleInventoryIndexRoute
  '/new-vehicle/lead-performance': typeof AuthenticatedNewVehicleLeadPerformanceIndexRoute
  '/new-vehicle/offers': typeof AuthenticatedNewVehicleOffersIndexRoute
  '/new-vehicle/planning': typeof AuthenticatedNewVehiclePlanningIndexRoute
  '/new-vehicle/price-lists': typeof AuthenticatedNewVehiclePriceListsIndexRoute
  '/new-vehicle/retails': typeof AuthenticatedNewVehicleRetailsIndexRoute
  '/new-vehicle/substitutes': typeof AuthenticatedNewVehicleSubstitutesIndexRoute
  '/new-vehicle/transfer-leads': typeof AuthenticatedNewVehicleTransferLeadsIndexRoute
  '/used-vehicle-buyer/contact-ops': typeof AuthenticatedUsedVehicleBuyerContactOpsIndexRoute
  '/used-vehicle-buyer/lead-performance': typeof AuthenticatedUsedVehicleBuyerLeadPerformanceIndexRoute
  '/used-vehicle-buyer/planning': typeof AuthenticatedUsedVehicleBuyerPlanningIndexRoute
  '/used-vehicle-seller/contact-ops': typeof AuthenticatedUsedVehicleSellerContactOpsIndexRoute
  '/used-vehicle-seller/lead-performance': typeof AuthenticatedUsedVehicleSellerLeadPerformanceIndexRoute
  '/used-vehicle-seller/planning': typeof AuthenticatedUsedVehicleSellerPlanningIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/(auth)/forgot-password': typeof authForgotPasswordRoute
  '/(auth)/sign-in': typeof authSignInRoute
  '/(auth)/sign-up': typeof authSignUpRoute
  '/(errors)/401': typeof errors401Route
  '/(errors)/403': typeof errors403Route
  '/(errors)/404': typeof errors404Route
  '/(errors)/500': typeof errors500Route
  '/(errors)/503': typeof errors503Route
  '/_authenticated/$tab': typeof AuthenticatedTabRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/frontline/': typeof AuthenticatedFrontlineIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/tracking/': typeof AuthenticatedTrackingIndexRoute
  '/_authenticated/generic/auto-exclusions/': typeof AuthenticatedGenericAutoExclusionsIndexRoute
  '/_authenticated/generic/branch/': typeof AuthenticatedGenericBranchIndexRoute
  '/_authenticated/generic/business-agents/': typeof AuthenticatedGenericBusinessAgentsIndexRoute
  '/_authenticated/generic/configuration/': typeof AuthenticatedGenericConfigurationIndexRoute
  '/_authenticated/generic/integrations/': typeof AuthenticatedGenericIntegrationsIndexRoute
  '/_authenticated/generic/models/': typeof AuthenticatedGenericModelsIndexRoute
  '/_authenticated/generic/users/': typeof AuthenticatedGenericUsersIndexRoute
  '/_authenticated/new-vehicle/bookings/': typeof AuthenticatedNewVehicleBookingsIndexRoute
  '/_authenticated/new-vehicle/contact-ops/': typeof AuthenticatedNewVehicleContactOpsIndexRoute
  '/_authenticated/new-vehicle/customers/': typeof AuthenticatedNewVehicleCustomersIndexRoute
  '/_authenticated/new-vehicle/funnel-setup/': typeof AuthenticatedNewVehicleFunnelSetupIndexRoute
  '/_authenticated/new-vehicle/imported-leads/': typeof AuthenticatedNewVehicleImportedLeadsIndexRoute
  '/_authenticated/new-vehicle/inventory/': typeof AuthenticatedNewVehicleInventoryIndexRoute
  '/_authenticated/new-vehicle/lead-performance/': typeof AuthenticatedNewVehicleLeadPerformanceIndexRoute
  '/_authenticated/new-vehicle/offers/': typeof AuthenticatedNewVehicleOffersIndexRoute
  '/_authenticated/new-vehicle/planning/': typeof AuthenticatedNewVehiclePlanningIndexRoute
  '/_authenticated/new-vehicle/price-lists/': typeof AuthenticatedNewVehiclePriceListsIndexRoute
  '/_authenticated/new-vehicle/retails/': typeof AuthenticatedNewVehicleRetailsIndexRoute
  '/_authenticated/new-vehicle/substitutes/': typeof AuthenticatedNewVehicleSubstitutesIndexRoute
  '/_authenticated/new-vehicle/transfer-leads/': typeof AuthenticatedNewVehicleTransferLeadsIndexRoute
  '/_authenticated/used-vehicle-buyer/contact-ops/': typeof AuthenticatedUsedVehicleBuyerContactOpsIndexRoute
  '/_authenticated/used-vehicle-buyer/lead-performance/': typeof AuthenticatedUsedVehicleBuyerLeadPerformanceIndexRoute
  '/_authenticated/used-vehicle-buyer/planning/': typeof AuthenticatedUsedVehicleBuyerPlanningIndexRoute
  '/_authenticated/used-vehicle-seller/contact-ops/': typeof AuthenticatedUsedVehicleSellerContactOpsIndexRoute
  '/_authenticated/used-vehicle-seller/lead-performance/': typeof AuthenticatedUsedVehicleSellerLeadPerformanceIndexRoute
  '/_authenticated/used-vehicle-seller/planning/': typeof AuthenticatedUsedVehicleSellerPlanningIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/forgot-password'
    | '/sign-in'
    | '/sign-up'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/$tab'
    | '/'
    | '/frontline'
    | '/settings'
    | '/tracking'
    | '/generic/auto-exclusions'
    | '/generic/branch'
    | '/generic/business-agents'
    | '/generic/configuration'
    | '/generic/integrations'
    | '/generic/models'
    | '/generic/users'
    | '/new-vehicle/bookings'
    | '/new-vehicle/contact-ops'
    | '/new-vehicle/customers'
    | '/new-vehicle/funnel-setup'
    | '/new-vehicle/imported-leads'
    | '/new-vehicle/inventory'
    | '/new-vehicle/lead-performance'
    | '/new-vehicle/offers'
    | '/new-vehicle/planning'
    | '/new-vehicle/price-lists'
    | '/new-vehicle/retails'
    | '/new-vehicle/substitutes'
    | '/new-vehicle/transfer-leads'
    | '/used-vehicle-buyer/contact-ops'
    | '/used-vehicle-buyer/lead-performance'
    | '/used-vehicle-buyer/planning'
    | '/used-vehicle-seller/contact-ops'
    | '/used-vehicle-seller/lead-performance'
    | '/used-vehicle-seller/planning'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/sign-in'
    | '/sign-up'
    | '/401'
    | '/403'
    | '/404'
    | '/500'
    | '/503'
    | '/$tab'
    | '/'
    | '/frontline'
    | '/settings'
    | '/tracking'
    | '/generic/auto-exclusions'
    | '/generic/branch'
    | '/generic/business-agents'
    | '/generic/configuration'
    | '/generic/integrations'
    | '/generic/models'
    | '/generic/users'
    | '/new-vehicle/bookings'
    | '/new-vehicle/contact-ops'
    | '/new-vehicle/customers'
    | '/new-vehicle/funnel-setup'
    | '/new-vehicle/imported-leads'
    | '/new-vehicle/inventory'
    | '/new-vehicle/lead-performance'
    | '/new-vehicle/offers'
    | '/new-vehicle/planning'
    | '/new-vehicle/price-lists'
    | '/new-vehicle/retails'
    | '/new-vehicle/substitutes'
    | '/new-vehicle/transfer-leads'
    | '/used-vehicle-buyer/contact-ops'
    | '/used-vehicle-buyer/lead-performance'
    | '/used-vehicle-buyer/planning'
    | '/used-vehicle-seller/contact-ops'
    | '/used-vehicle-seller/lead-performance'
    | '/used-vehicle-seller/planning'
  id:
    | '__root__'
    | '/_authenticated'
    | '/(auth)/forgot-password'
    | '/(auth)/sign-in'
    | '/(auth)/sign-up'
    | '/(errors)/401'
    | '/(errors)/403'
    | '/(errors)/404'
    | '/(errors)/500'
    | '/(errors)/503'
    | '/_authenticated/$tab'
    | '/_authenticated/'
    | '/_authenticated/frontline/'
    | '/_authenticated/settings/'
    | '/_authenticated/tracking/'
    | '/_authenticated/generic/auto-exclusions/'
    | '/_authenticated/generic/branch/'
    | '/_authenticated/generic/business-agents/'
    | '/_authenticated/generic/configuration/'
    | '/_authenticated/generic/integrations/'
    | '/_authenticated/generic/models/'
    | '/_authenticated/generic/users/'
    | '/_authenticated/new-vehicle/bookings/'
    | '/_authenticated/new-vehicle/contact-ops/'
    | '/_authenticated/new-vehicle/customers/'
    | '/_authenticated/new-vehicle/funnel-setup/'
    | '/_authenticated/new-vehicle/imported-leads/'
    | '/_authenticated/new-vehicle/inventory/'
    | '/_authenticated/new-vehicle/lead-performance/'
    | '/_authenticated/new-vehicle/offers/'
    | '/_authenticated/new-vehicle/planning/'
    | '/_authenticated/new-vehicle/price-lists/'
    | '/_authenticated/new-vehicle/retails/'
    | '/_authenticated/new-vehicle/substitutes/'
    | '/_authenticated/new-vehicle/transfer-leads/'
    | '/_authenticated/used-vehicle-buyer/contact-ops/'
    | '/_authenticated/used-vehicle-buyer/lead-performance/'
    | '/_authenticated/used-vehicle-buyer/planning/'
    | '/_authenticated/used-vehicle-seller/contact-ops/'
    | '/_authenticated/used-vehicle-seller/lead-performance/'
    | '/_authenticated/used-vehicle-seller/planning/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  authForgotPasswordRoute: typeof authForgotPasswordRoute
  authSignInRoute: typeof authSignInRoute
  authSignUpRoute: typeof authSignUpRoute
  errors401Route: typeof errors401Route
  errors403Route: typeof errors403Route
  errors404Route: typeof errors404Route
  errors500Route: typeof errors500Route
  errors503Route: typeof errors503Route
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/$tab': {
      id: '/_authenticated/$tab'
      path: '/$tab'
      fullPath: '/$tab'
      preLoaderRoute: typeof AuthenticatedTabRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/(errors)/503': {
      id: '/(errors)/503'
      path: '/503'
      fullPath: '/503'
      preLoaderRoute: typeof errors503RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/500': {
      id: '/(errors)/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof errors500RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/404': {
      id: '/(errors)/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof errors404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/403': {
      id: '/(errors)/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof errors403RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(errors)/401': {
      id: '/(errors)/401'
      path: '/401'
      fullPath: '/401'
      preLoaderRoute: typeof errors401RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-up': {
      id: '/(auth)/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof authSignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/sign-in': {
      id: '/(auth)/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof authSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)/forgot-password': {
      id: '/(auth)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof authForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/tracking/': {
      id: '/_authenticated/tracking/'
      path: '/tracking'
      fullPath: '/tracking'
      preLoaderRoute: typeof AuthenticatedTrackingIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/frontline/': {
      id: '/_authenticated/frontline/'
      path: '/frontline'
      fullPath: '/frontline'
      preLoaderRoute: typeof AuthenticatedFrontlineIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/used-vehicle-seller/planning/': {
      id: '/_authenticated/used-vehicle-seller/planning/'
      path: '/used-vehicle-seller/planning'
      fullPath: '/used-vehicle-seller/planning'
      preLoaderRoute: typeof AuthenticatedUsedVehicleSellerPlanningIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/used-vehicle-seller/lead-performance/': {
      id: '/_authenticated/used-vehicle-seller/lead-performance/'
      path: '/used-vehicle-seller/lead-performance'
      fullPath: '/used-vehicle-seller/lead-performance'
      preLoaderRoute: typeof AuthenticatedUsedVehicleSellerLeadPerformanceIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/used-vehicle-seller/contact-ops/': {
      id: '/_authenticated/used-vehicle-seller/contact-ops/'
      path: '/used-vehicle-seller/contact-ops'
      fullPath: '/used-vehicle-seller/contact-ops'
      preLoaderRoute: typeof AuthenticatedUsedVehicleSellerContactOpsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/used-vehicle-buyer/planning/': {
      id: '/_authenticated/used-vehicle-buyer/planning/'
      path: '/used-vehicle-buyer/planning'
      fullPath: '/used-vehicle-buyer/planning'
      preLoaderRoute: typeof AuthenticatedUsedVehicleBuyerPlanningIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/used-vehicle-buyer/lead-performance/': {
      id: '/_authenticated/used-vehicle-buyer/lead-performance/'
      path: '/used-vehicle-buyer/lead-performance'
      fullPath: '/used-vehicle-buyer/lead-performance'
      preLoaderRoute: typeof AuthenticatedUsedVehicleBuyerLeadPerformanceIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/used-vehicle-buyer/contact-ops/': {
      id: '/_authenticated/used-vehicle-buyer/contact-ops/'
      path: '/used-vehicle-buyer/contact-ops'
      fullPath: '/used-vehicle-buyer/contact-ops'
      preLoaderRoute: typeof AuthenticatedUsedVehicleBuyerContactOpsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/new-vehicle/transfer-leads/': {
      id: '/_authenticated/new-vehicle/transfer-leads/'
      path: '/new-vehicle/transfer-leads'
      fullPath: '/new-vehicle/transfer-leads'
      preLoaderRoute: typeof AuthenticatedNewVehicleTransferLeadsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/new-vehicle/substitutes/': {
      id: '/_authenticated/new-vehicle/substitutes/'
      path: '/new-vehicle/substitutes'
      fullPath: '/new-vehicle/substitutes'
      preLoaderRoute: typeof AuthenticatedNewVehicleSubstitutesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/new-vehicle/retails/': {
      id: '/_authenticated/new-vehicle/retails/'
      path: '/new-vehicle/retails'
      fullPath: '/new-vehicle/retails'
      preLoaderRoute: typeof AuthenticatedNewVehicleRetailsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/new-vehicle/price-lists/': {
      id: '/_authenticated/new-vehicle/price-lists/'
      path: '/new-vehicle/price-lists'
      fullPath: '/new-vehicle/price-lists'
      preLoaderRoute: typeof AuthenticatedNewVehiclePriceListsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/new-vehicle/planning/': {
      id: '/_authenticated/new-vehicle/planning/'
      path: '/new-vehicle/planning'
      fullPath: '/new-vehicle/planning'
      preLoaderRoute: typeof AuthenticatedNewVehiclePlanningIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/new-vehicle/offers/': {
      id: '/_authenticated/new-vehicle/offers/'
      path: '/new-vehicle/offers'
      fullPath: '/new-vehicle/offers'
      preLoaderRoute: typeof AuthenticatedNewVehicleOffersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/new-vehicle/lead-performance/': {
      id: '/_authenticated/new-vehicle/lead-performance/'
      path: '/new-vehicle/lead-performance'
      fullPath: '/new-vehicle/lead-performance'
      preLoaderRoute: typeof AuthenticatedNewVehicleLeadPerformanceIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/new-vehicle/inventory/': {
      id: '/_authenticated/new-vehicle/inventory/'
      path: '/new-vehicle/inventory'
      fullPath: '/new-vehicle/inventory'
      preLoaderRoute: typeof AuthenticatedNewVehicleInventoryIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/new-vehicle/imported-leads/': {
      id: '/_authenticated/new-vehicle/imported-leads/'
      path: '/new-vehicle/imported-leads'
      fullPath: '/new-vehicle/imported-leads'
      preLoaderRoute: typeof AuthenticatedNewVehicleImportedLeadsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/new-vehicle/funnel-setup/': {
      id: '/_authenticated/new-vehicle/funnel-setup/'
      path: '/new-vehicle/funnel-setup'
      fullPath: '/new-vehicle/funnel-setup'
      preLoaderRoute: typeof AuthenticatedNewVehicleFunnelSetupIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/new-vehicle/customers/': {
      id: '/_authenticated/new-vehicle/customers/'
      path: '/new-vehicle/customers'
      fullPath: '/new-vehicle/customers'
      preLoaderRoute: typeof AuthenticatedNewVehicleCustomersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/new-vehicle/contact-ops/': {
      id: '/_authenticated/new-vehicle/contact-ops/'
      path: '/new-vehicle/contact-ops'
      fullPath: '/new-vehicle/contact-ops'
      preLoaderRoute: typeof AuthenticatedNewVehicleContactOpsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/new-vehicle/bookings/': {
      id: '/_authenticated/new-vehicle/bookings/'
      path: '/new-vehicle/bookings'
      fullPath: '/new-vehicle/bookings'
      preLoaderRoute: typeof AuthenticatedNewVehicleBookingsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/generic/users/': {
      id: '/_authenticated/generic/users/'
      path: '/generic/users'
      fullPath: '/generic/users'
      preLoaderRoute: typeof AuthenticatedGenericUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/generic/models/': {
      id: '/_authenticated/generic/models/'
      path: '/generic/models'
      fullPath: '/generic/models'
      preLoaderRoute: typeof AuthenticatedGenericModelsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/generic/integrations/': {
      id: '/_authenticated/generic/integrations/'
      path: '/generic/integrations'
      fullPath: '/generic/integrations'
      preLoaderRoute: typeof AuthenticatedGenericIntegrationsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/generic/configuration/': {
      id: '/_authenticated/generic/configuration/'
      path: '/generic/configuration'
      fullPath: '/generic/configuration'
      preLoaderRoute: typeof AuthenticatedGenericConfigurationIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/generic/business-agents/': {
      id: '/_authenticated/generic/business-agents/'
      path: '/generic/business-agents'
      fullPath: '/generic/business-agents'
      preLoaderRoute: typeof AuthenticatedGenericBusinessAgentsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/generic/branch/': {
      id: '/_authenticated/generic/branch/'
      path: '/generic/branch'
      fullPath: '/generic/branch'
      preLoaderRoute: typeof AuthenticatedGenericBranchIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/generic/auto-exclusions/': {
      id: '/_authenticated/generic/auto-exclusions/'
      path: '/generic/auto-exclusions'
      fullPath: '/generic/auto-exclusions'
      preLoaderRoute: typeof AuthenticatedGenericAutoExclusionsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthenticatedRouteRouteChildren {
  AuthenticatedTabRoute: typeof AuthenticatedTabRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedFrontlineIndexRoute: typeof AuthenticatedFrontlineIndexRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
  AuthenticatedTrackingIndexRoute: typeof AuthenticatedTrackingIndexRoute
  AuthenticatedGenericAutoExclusionsIndexRoute: typeof AuthenticatedGenericAutoExclusionsIndexRoute
  AuthenticatedGenericBranchIndexRoute: typeof AuthenticatedGenericBranchIndexRoute
  AuthenticatedGenericBusinessAgentsIndexRoute: typeof AuthenticatedGenericBusinessAgentsIndexRoute
  AuthenticatedGenericConfigurationIndexRoute: typeof AuthenticatedGenericConfigurationIndexRoute
  AuthenticatedGenericIntegrationsIndexRoute: typeof AuthenticatedGenericIntegrationsIndexRoute
  AuthenticatedGenericModelsIndexRoute: typeof AuthenticatedGenericModelsIndexRoute
  AuthenticatedGenericUsersIndexRoute: typeof AuthenticatedGenericUsersIndexRoute
  AuthenticatedNewVehicleBookingsIndexRoute: typeof AuthenticatedNewVehicleBookingsIndexRoute
  AuthenticatedNewVehicleContactOpsIndexRoute: typeof AuthenticatedNewVehicleContactOpsIndexRoute
  AuthenticatedNewVehicleCustomersIndexRoute: typeof AuthenticatedNewVehicleCustomersIndexRoute
  AuthenticatedNewVehicleFunnelSetupIndexRoute: typeof AuthenticatedNewVehicleFunnelSetupIndexRoute
  AuthenticatedNewVehicleImportedLeadsIndexRoute: typeof AuthenticatedNewVehicleImportedLeadsIndexRoute
  AuthenticatedNewVehicleInventoryIndexRoute: typeof AuthenticatedNewVehicleInventoryIndexRoute
  AuthenticatedNewVehicleLeadPerformanceIndexRoute: typeof AuthenticatedNewVehicleLeadPerformanceIndexRoute
  AuthenticatedNewVehicleOffersIndexRoute: typeof AuthenticatedNewVehicleOffersIndexRoute
  AuthenticatedNewVehiclePlanningIndexRoute: typeof AuthenticatedNewVehiclePlanningIndexRoute
  AuthenticatedNewVehiclePriceListsIndexRoute: typeof AuthenticatedNewVehiclePriceListsIndexRoute
  AuthenticatedNewVehicleRetailsIndexRoute: typeof AuthenticatedNewVehicleRetailsIndexRoute
  AuthenticatedNewVehicleSubstitutesIndexRoute: typeof AuthenticatedNewVehicleSubstitutesIndexRoute
  AuthenticatedNewVehicleTransferLeadsIndexRoute: typeof AuthenticatedNewVehicleTransferLeadsIndexRoute
  AuthenticatedUsedVehicleBuyerContactOpsIndexRoute: typeof AuthenticatedUsedVehicleBuyerContactOpsIndexRoute
  AuthenticatedUsedVehicleBuyerLeadPerformanceIndexRoute: typeof AuthenticatedUsedVehicleBuyerLeadPerformanceIndexRoute
  AuthenticatedUsedVehicleBuyerPlanningIndexRoute: typeof AuthenticatedUsedVehicleBuyerPlanningIndexRoute
  AuthenticatedUsedVehicleSellerContactOpsIndexRoute: typeof AuthenticatedUsedVehicleSellerContactOpsIndexRoute
  AuthenticatedUsedVehicleSellerLeadPerformanceIndexRoute: typeof AuthenticatedUsedVehicleSellerLeadPerformanceIndexRoute
  AuthenticatedUsedVehicleSellerPlanningIndexRoute: typeof AuthenticatedUsedVehicleSellerPlanningIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedTabRoute: AuthenticatedTabRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedFrontlineIndexRoute: AuthenticatedFrontlineIndexRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
  AuthenticatedTrackingIndexRoute: AuthenticatedTrackingIndexRoute,
  AuthenticatedGenericAutoExclusionsIndexRoute:
    AuthenticatedGenericAutoExclusionsIndexRoute,
  AuthenticatedGenericBranchIndexRoute: AuthenticatedGenericBranchIndexRoute,
  AuthenticatedGenericBusinessAgentsIndexRoute:
    AuthenticatedGenericBusinessAgentsIndexRoute,
  AuthenticatedGenericConfigurationIndexRoute:
    AuthenticatedGenericConfigurationIndexRoute,
  AuthenticatedGenericIntegrationsIndexRoute:
    AuthenticatedGenericIntegrationsIndexRoute,
  AuthenticatedGenericModelsIndexRoute: AuthenticatedGenericModelsIndexRoute,
  AuthenticatedGenericUsersIndexRoute: AuthenticatedGenericUsersIndexRoute,
  AuthenticatedNewVehicleBookingsIndexRoute:
    AuthenticatedNewVehicleBookingsIndexRoute,
  AuthenticatedNewVehicleContactOpsIndexRoute:
    AuthenticatedNewVehicleContactOpsIndexRoute,
  AuthenticatedNewVehicleCustomersIndexRoute:
    AuthenticatedNewVehicleCustomersIndexRoute,
  AuthenticatedNewVehicleFunnelSetupIndexRoute:
    AuthenticatedNewVehicleFunnelSetupIndexRoute,
  AuthenticatedNewVehicleImportedLeadsIndexRoute:
    AuthenticatedNewVehicleImportedLeadsIndexRoute,
  AuthenticatedNewVehicleInventoryIndexRoute:
    AuthenticatedNewVehicleInventoryIndexRoute,
  AuthenticatedNewVehicleLeadPerformanceIndexRoute:
    AuthenticatedNewVehicleLeadPerformanceIndexRoute,
  AuthenticatedNewVehicleOffersIndexRoute:
    AuthenticatedNewVehicleOffersIndexRoute,
  AuthenticatedNewVehiclePlanningIndexRoute:
    AuthenticatedNewVehiclePlanningIndexRoute,
  AuthenticatedNewVehiclePriceListsIndexRoute:
    AuthenticatedNewVehiclePriceListsIndexRoute,
  AuthenticatedNewVehicleRetailsIndexRoute:
    AuthenticatedNewVehicleRetailsIndexRoute,
  AuthenticatedNewVehicleSubstitutesIndexRoute:
    AuthenticatedNewVehicleSubstitutesIndexRoute,
  AuthenticatedNewVehicleTransferLeadsIndexRoute:
    AuthenticatedNewVehicleTransferLeadsIndexRoute,
  AuthenticatedUsedVehicleBuyerContactOpsIndexRoute:
    AuthenticatedUsedVehicleBuyerContactOpsIndexRoute,
  AuthenticatedUsedVehicleBuyerLeadPerformanceIndexRoute:
    AuthenticatedUsedVehicleBuyerLeadPerformanceIndexRoute,
  AuthenticatedUsedVehicleBuyerPlanningIndexRoute:
    AuthenticatedUsedVehicleBuyerPlanningIndexRoute,
  AuthenticatedUsedVehicleSellerContactOpsIndexRoute:
    AuthenticatedUsedVehicleSellerContactOpsIndexRoute,
  AuthenticatedUsedVehicleSellerLeadPerformanceIndexRoute:
    AuthenticatedUsedVehicleSellerLeadPerformanceIndexRoute,
  AuthenticatedUsedVehicleSellerPlanningIndexRoute:
    AuthenticatedUsedVehicleSellerPlanningIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  authForgotPasswordRoute: authForgotPasswordRoute,
  authSignInRoute: authSignInRoute,
  authSignUpRoute: authSignUpRoute,
  errors401Route: errors401Route,
  errors403Route: errors403Route,
  errors404Route: errors404Route,
  errors500Route: errors500Route,
  errors503Route: errors503Route,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
